import type { ProjectTrack, ProjectDayActivity } from '../types/activity';
import type { Child } from '../types/child';
import { useProjectStore } from '../store/projectStore';
import projectTracksData from '../data/project-tracks.json';

const allTracks = projectTracksData as ProjectTrack[];

export function getAllProjectTracks(): ProjectTrack[] {
  return allTracks;
}

export function getProjectTrackById(id: string): ProjectTrack | undefined {
  return allTracks.find(t => t.id === id);
}

export function getAvailableProjects(child: Child): ProjectTrack[] {
  return allTracks.filter(track =>
    track.ageGroups.includes(child.ageGroup)
  );
}

export function getNextProjectDay(
  childId: string,
  trackId: string,
): ProjectDayActivity | null {
  const progress = useProjectStore.getState().getProjectProgress(childId, trackId);
  if (!progress) return null;

  const track = getProjectTrackById(trackId);
  if (!track) return null;

  // Find the first day that hasn't been completed
  const nextDay = track.dailyActivities.find(
    day => !progress.completedDays.includes(day.dayNumber)
  );

  return nextDay || null;
}

export function isProjectComplete(childId: string, trackId: string): boolean {
  const progress = useProjectStore.getState().getProjectProgress(childId, trackId);
  if (!progress) return false;

  const track = getProjectTrackById(trackId);
  if (!track) return false;

  return progress.completedDays.length >= track.totalDays;
}
